import classNames from 'classnames';
import React from 'react';

type ProductImageCarouselDotsProps = {
  imgIndex: number;
  items: any[];
  onChangeIndex: (index: number) => void;
};

const ProductImageCarouselDots = (props: ProductImageCarouselDotsProps) => {
  const { imgIndex, items, onChangeIndex } = props;

  return (
    <div className="product-image-carousel-dots">
      {items?.map((_, index) => (
        <span
          key={`product-image-carousel-dot-${index}`}
          role="navigation"
          className={classNames('product-image-carousel-dot', {
            'product-image-carousel-dot--active': imgIndex === index,
          })}
          onClick={() => onChangeIndex(index)}
        />
      ))}
    </div>
  );
};

export default ProductImageCarouselDots;
